import React from 'react';
import { connect } from 'react-redux';
import taskGroupsActions from '../../store/task-groups/action-creators/index';
import TaskGroupForm from './TaskGroupForm';

const TaskGroupAdd = (props) => {
  // ----------------------
  // Render
  // ----------------------

  return (
    <TaskGroupForm
      initialValues={props.initialValues}
      isLoading={props.isLoading}
      onSave={(data) => props.createTaskGroup({
        ...data,
        parent_guid: props.taskGroupGuid
      }).then(() => {
        props.onFinish && props.onFinish()
      })}
    />
  );
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.taskGroups.isLoading.includes('createTaskGroup'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createTaskGroup: formData => dispatch(taskGroupsActions.createTaskGroup(formData)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskGroupAdd);
